import React, { useEffect, useState } from "react";
import Button from "./Button";
import { Image, PseudoBox } from "@chakra-ui/react";
import { Flex, Wrap, Container, Text } from "@chakra-ui/react";
import { FaGithub, FaLinkedin, FaTelegram, FaGitlab } from "react-icons/fa";

const Profile = () => {
  return (
    <>
      <Container
        display="flex"
        flexDirection="column"
        alignItems="center"
        marginTop="8rem"
        justifyContent="center"
        backgroundColor="#1a202c"
      >
        <Image
          borderRadius="full"
          boxSize="150px"
          marginBottom="1rem"
          src={require("../assets/hope.jpg")}
        />{" "}
        <Text fontSize="8xl" color="white" fontFamily="Rajdhani, sans-serif">
          Hope G
        </Text>
        <Text
          fontSize="1xl"
          color="white"
          marginBottom="5rem"
          fontFamily="Comfortaa, sans-serif"
        >
          Fullstack Developer
        </Text>
        <Flex
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="6rem"
          gap="5rem"
        >
          <FaGithub
            style={{ color: "white", fontSize: "50px", marginRight: "3rem" }}
          ></FaGithub>
          <FaLinkedin
            style={{ color: "#0072b1", fontSize: "50px", marginRight: "3rem" }}
          ></FaLinkedin>
          <FaTelegram
            style={{ color: "#0088cc", fontSize: "50px", marginRight: "3rem" }}
          ></FaTelegram>
          <FaGitlab
            style={{ color: "#fca326", fontSize: "50px", marginRight: "3rem" }}
          ></FaGitlab>
        </Flex>
        <Container marginBottom="14rem">
          <Button text="Contact Me" />
        </Container>
        {/* <ScrollComponent text="Skill" to="skills" /> */}
      </Container>
    </>
  );
};

export default Profile;